import React, { useState } from 'react';
import { useStoreInfo } from '../../hooks/useApi';
import { useCart } from '../../contexts/CartContext';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { state } = useCart();
  const { data: storeInfo, loading } = useStoreInfo();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <div className="nav-brand">
            <h1 className="brand-title">
              {loading ? (
                <div className="skeleton-line" style={{ height: '40px', width: '200px' }}></div>
              ) : (
                storeInfo?.name || 'חיי קדושה'
              )}
            </h1>
            <p className="brand-tagline">
              {loading ? (
                <div className="skeleton-line" style={{ height: '20px', width: '150px' }}></div>
              ) : (
                storeInfo?.tagline || 'החנות של מתן וליאור'
              )}
            </p>
          </div>
          
          <div className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
            <a href="#home" className="nav-link">בית</a>
            <a href="#items" className="nav-link">מוצרים</a>
            <a href="#contact" className="nav-link">צור קשר</a>
            <a href="#cart" className="nav-link cart-link">
              <span className="cart-icon">🛒</span>
              עגלה
              {state.totalItems > 0 && (
                <span className="cart-count">{state.totalItems}</span>
              )}
            </a>
          </div>
          
          <button 
            className="nav-toggle"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className="hamburger"></span>
            <span className="hamburger"></span>
            <span className="hamburger"></span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;

